// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArrowUpRight = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M49.1053 16.8229C49.0639 15.6508 48.3493 14.9363 47.1772 14.8949C46.0052 14.8534 21.2218 13.9762 19.9576 13.9315C18.6934 13.8867 17.8869 14.6652 17.8869 15.9302V19.7863C17.8869 21.0513 18.6934 21.8297 19.9576 21.785C20.7559 21.7567 30.9831 21.3948 38.4156 21.1317C31.5796 27.6137 15.7961 42.5801 15.0787 43.2658C14.1615 44.1421 14.1488 45.2621 15.0458 46.1591L17.8411 48.9545C18.7381 49.8513 19.8581 49.8386 20.7344 48.9215C21.42 48.204 36.3866 32.4205 42.8685 25.5846C42.6054 33.0172 42.2434 43.2443 42.2152 44.0426C42.1704 45.3068 42.9489 46.1133 44.2139 46.1133C45.4789 46.1132 46.805 46.1132 48.07 46.1132C49.335 46.1132 50.1134 45.3068 50.0688 44.0426C50.024 42.7783 49.1468 17.995 49.1053 16.8229Z" />
    </svg>
  );
};
